import { EntityModel } from '@/interfaces'
import {
  ALL_MAP_MARKERS_QUERY,
  CREATE_MAP_MARKER_MUTATION,
  DELETE_MAP_MARKER_MUTATION,
  FORCE_DELETE_MAP_MARKER_MUTATION,
  SINGLE_MAP_MARKER_QUERY,
  UPDATE_MAP_MARKER_MUTATION,
} from './graphql'

const itineraryMapMarkerModel: EntityModel = {
  name: 'mapMarker',
  namePlural: 'mapMarkers',
  uniqueName: 'itineraryMapMarker',
  uniqueNamePlural: 'itineraryMapMarkers',
  path: 'travel/itinerary/map_marker',
  baseUrl: '/travel/itinerary/map_markers',
  translationPrefix: 'entities:itineraryMapMarker.',
  getDisplayName: (values: any) => {
    return 'Map Marker'
  },
  gql: {
    getAll: ALL_MAP_MARKERS_QUERY,
    getSingle: SINGLE_MAP_MARKER_QUERY,
    create: CREATE_MAP_MARKER_MUTATION,
    update: UPDATE_MAP_MARKER_MUTATION,
    delete: DELETE_MAP_MARKER_MUTATION,
    forceDelete: FORCE_DELETE_MAP_MARKER_MUTATION,
  },
  attributes: {
    lat: {
      name: 'lat',
      label: 'entities:itineraryMapMarker.attributes.lat.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
        {
          type: 'regex',
          pattern: /^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?)$/,
        },
      ],
    },
    lng: {
      name: 'lng',
      label: 'entities:itineraryMapMarker.attributes.lng.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
        {
          type: 'regex',
          pattern: /^[-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?)$/,
        },
      ],
    },
  },
}

export default itineraryMapMarkerModel
